import { useContext } from "react";
import "./targets.scss"
import { Link } from "react-router-dom";
import api  from "../../services/api";
import { AuthContext } from "../../context/authContext"
import { useEffect, useState } from "react";

const TargetsList = () => {
 
const [targets, setTargets] = useState([]);
  useEffect(() => {
    const fetchTargets = async () => {
      try {
        const res = await api.get(`/api/osint/list_targets/`);
        // We want to keep the first 3 targets at the top
        const allTargets = res.data; //.slice(0, 3);
        setTargets(allTargets);
      } catch (err) {
        console.error(err);
      }
    };
    fetchTargets();
  },[]);
  
  // Sort targets alphabetically by name
  const sortedTargets = [...targets].sort((a, b) => a.name.localeCompare(b.name));

  // Group targets by the first character
  const groupedTargets = sortedTargets.reduce((groups, target) => {
    const firstChar = target.name.charAt(0).toUpperCase();
    if (!groups[firstChar]) {
      groups[firstChar] = [];
    }
    groups[firstChar].push(target);
    return groups;
  }, {});

  // Get sorted group keys
  const groupKeys = Object.keys(groupedTargets).sort();

  return (
    <><div className="group-navigation">
    {groupKeys.map((group) => (
      <a key={group} href={`#group-${group}`} style={{ marginRight: '10px' }}>
        {group}
      </a>
    ))}
  </div>
    <div className="targetsBanner">
    {/* Top Navigation Links */}
    
      <div className="target">
          <img src="/images/new_target.png" alt="" />
          <Link
              to="/targets/new"
              style={{ textDecoration: "none", color: "inherit" }}
            >
          <button>+</button>
          </Link>
        </div>
      </div>
          <div className="targetsBanner">
        

         {/* Target Groups */}
      {groupKeys.map((group) => (
        <div key={group} id={`group-${group}`}>
          <h3>{group}</h3>
          {groupedTargets[group].map(target => (
            <div className="target" key={target.id}>
              <img src={target.img} alt="" />
              <span>
                <Link to={`/target/${target.id}`} style={{ textDecoration: "none", color: "inherit" }}>
                  {target.name}
                </Link>
              </span>
            </div>
          ))}
          {/* Back to Top Link */}
          <div style={{ marginTop: '10px' }}>
            <a href="#top">Back to Top</a>
          </div>
        </div>
      ))}
    </div>
    </>
  )
 
}

export default TargetsList